import {
    type LoanRequestNotificationLeadsResolver,
    schemaLoanRequestNotificationLeads,
    type SchemaLoanRequestNotificationLeads,
} from './notificationLeads';

export const schemaLoanRequestResolver_GetAddedAssignedUserLeads = schemaLoanRequestNotificationLeads;

export type SchemaLoanRequestResolver_GetAddedAssignedUserLeads = SchemaLoanRequestNotificationLeads;

export type LoanRequestResolver_GetAddedAssignedUserLeads = LoanRequestNotificationLeadsResolver;
